import { render, staticRenderFns } from "./laualist.vue?vue&type=template&id=890b9bfa&"
import script from "./laualist.vue?vue&type=script&lang=js&"
export * from "./laualist.vue?vue&type=script&lang=js&"
import style0 from "./laualist.vue?vue&type=style&index=0&id=890b9bfa&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('890b9bfa')) {
      api.createRecord('890b9bfa', component.options)
    } else {
      api.reload('890b9bfa', component.options)
    }
    module.hot.accept("./laualist.vue?vue&type=template&id=890b9bfa&", function () {
      api.rerender('890b9bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/revenueSsharing/laualist.vue"
export default component.exports